import React, { useEffect, useState } from "react"
import { showToast } from "../../../Common/Messages";
const DocFeedback = (props) => {

    const [feedBackCount, setFeedBackCount] = useState(null);
    const [feedBackList, setFeedBackList] = useState([]);

    useEffect(() => {
        if(props.docId)
            getFeedBack(props.docId);
    }, [props.docId])

    const getFeedBack = async (docId) => {
        const response = await fetch('api/Edit/GetDocumentsFeedBack?DocId=' + docId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
        });
        const result = await response.json();
        if (response.status === 200 && result.data) {
            const feedbackData = result.data.table1;
            setFeedBackCount(result.data.table.length > 0 ? result.data.table[0] : null);
            setFeedBackList(feedbackData);
        } else {
            showToast('danger', "피드백 조회를 실패했습니다. 다시 시도해주세요.");
            return;
        }
    };

    const count = () => {
        return (
            <div className="userFeedback-count-wrap">
                <div className="userFeedback-count">
                    <div className="userFeedback-count-label">
                        <i className="icoKdc20 like-g"></i>
                        <p className="count-name">도움이 됐어요</p>
                    </div>
                    <p className="count-number">{feedBackCount?.countLike || 0}</p>
                </div>
                <div className="userFeedback-count">
                    <div className="userFeedback-count-label">
                        <i className="icoKdc20 dislike-r"></i>
                        <p className="count-name">아쉬워요</p>
                    </div>
                    <p className="count-number">{feedBackCount?.countDislike || 0}</p>
                </div>
            </div>
        )
    }
    const contents = () => {
        if(feedBackList.length === 0) return;
        const feedBackInfo = {
            like: {class: "like-g", message: "도움이 됐어요"},
            dislike: {class: "dislike-r", message: "아쉬워요"}
        }
        return (
            <ul className="userFeedback-list">
                {feedBackList.map((feedback, index) => {
                    const [type, key] = feedback.feedBackID.split('-');
                    return (
                        <li key={index} className="userFeedback-item">
                            <div className="category">
                                <i className={`icoKdc20 ${feedBackInfo[type].class}`}></i>
                                <p className="category-txt"><span>{feedBackInfo[type].message}</span>가 추가되었습니다.</p>
                            </div>
                            <div className="description">{feedback.content ? feedback.content : feedback.comment}</div>
                            <p className="date">{feedback.updateDate}</p>
                        </li>
                    )
                })}
            </ul>
        )
    }
    return (
        <div className="editor-side userFeedback">
            <div className="editor-side-top">
                <h3 className='title'>사용자 피드백</h3>
                <button className="btn-close" onClick={props.onClose}>
                    <i className="icoKdc32 close"></i>
                </button>
            </div>
            <div className="editor-side-cnts">
                {count()}
                {contents()}
            </div>       
        </div>
    )
}
export default DocFeedback;